import {
    FETCH_HELP,
    FETCH_HELP_SUCCESS,
    FETCH_HELP_FAIL
} from './actionTypes';

const initialState = {
    data: null,
    error: null,
    loading: false,
    loaded: false
};

export function helpReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_HELP: {
            return {
                ...initialState,
                loading: true
            };
        }
        case FETCH_HELP_SUCCESS: {
            return {
                ...initialState,
                data: action.payload,
                loaded: true
            };
        }
        case FETCH_HELP_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        default:
            return state;
    }
}
